import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import SiteHeader from '@/components/landing/site-header'
import HeroShowcase from '@/components/landing/hero-showcase'
import PresenceStrip from '@/components/landing/presence-strip'
import DayAtHome from '@/components/landing/day-at-home'
import WithPeople from '@/components/landing/with-people'
import Engineering from '@/components/landing/engineering'
import Intelligence from '@/components/landing/intelligence'
import Safety from '@/components/landing/safety'
import Specs from '@/components/landing/specs'
import Reserve from '@/components/landing/reserve'
import SiteFooter from '@/components/landing/site-footer'

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo />

            <SiteHeader />

            <Layout>
                <HeroShowcase />
                <PresenceStrip />
                <DayAtHome />
                <WithPeople />
                <Engineering />
                <Intelligence />
                <Safety />
                <Specs />
                <Reserve />
            </Layout>

            <SiteFooter />
        </>
    )
}

export default Home
